import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import Features from './components/Features';
import SchemaOrg from '@/components/base/SchemaOrg';

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': '四虎影院 - 海量高清影视资源免费在线观看',
  'description': '四虎影院提供海量高清影视资源，涵盖电影、电视剧、综艺、动漫等多种类型，无需注册即可免费在线观看。每日更新最新影视内容，支持多线路流畅播放。',
  'url': 'https://realsmodel.cn/',
  'inLanguage': 'zh-CN',
  'isPartOf': {
    '@type': 'WebSite',
    'name': '四虎影院',
    'url': 'https://realsmodel.cn/',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={webPageSchema} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryGrid />
        <LatestUpdates />
        <Features />
      </main>
      <Footer />
    </>
  );
}